import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { QueryParams } from 'src/app/modules/core/store/models/query.model';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ControlActionType, TemplateViewControlAction, TemplateViewControlType } from 'src/app/modules/communications/store/communications';
import { TemplateDesignElementsRegistration } from '../design-elements/design-elements.map';

@Component({
    selector: 'topo-template-design-elements-selection',
    templateUrl: './design-elements-selection.component.html',
    styleUrls: ['./design-elements-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TemplateDesignElementsSelection implements OnInit, OnDestroy {
  elementTypes: any[];
  @Input() disabledElements: TemplateViewControlType[];
  @Input() set channelUId(value: string) {
    this.elementTypes = this.getElementTypes(value);
    this.changeDetector.markForCheck();
  }

  elementSections = [1, 2, 3, 4];

  public getElementTypes(channelUId: string): any {
    const elmTypes = [
      { value: TemplateViewControlType.NotificationMessage, section: 1, icon: 'icon-note_update', title: null },
      { value: TemplateViewControlType.ConfirmationMessage, section: 1, icon: 'icon-arrow-undo', title: null },
      { value: TemplateViewControlType.Image, section: 2, icon: 'icon-image', title: null },
      { value: TemplateViewControlType.Text, section: 2, icon: 'icon-text', title: null },
      { value: TemplateViewControlType.Header, section: 2, icon: 'icon-text', title: null },
      { value: TemplateViewControlType.Divider, section: 2, icon: 'icon-divider', title: null },
      { value: TemplateViewControlType.Button, section: 2, icon: 'icon-button', title: null },
      { value: TemplateViewControlType.FormField, section: 3, icon: 'icon-form-field', title: null },
      { value: TemplateViewControlType.Attachments, section: 3, icon: 'icon-attach', title: null },
      { value: TemplateViewControlType.Timeline, section: 3, icon: 'icon-timeline', title: null },
      { value: TemplateViewControlType.Map, section: 4, icon: 'icon-map', title: null },
      { value: TemplateViewControlType.SelectedAssets, section: 4, icon: 'icon-building', title: null },
      { value: TemplateViewControlType.NotificationRecipientsStatus, section: 3, icon: 'icon-table_2', title: null },
    ];

    const elmTypesForSelectedChannel = [];

    elmTypes.forEach(e => {
      const registration = TemplateDesignElementsRegistration.find(r => r.channelUId === channelUId && r.viewControlType == e.value);
      if (!!registration) {
        if (!!registration.desc) {
          e.title = registration.desc;
        } else {
          e.title = 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + e.value;
        }
        if (!!registration.icon) {
          e.icon = registration.icon;
        }
        elmTypesForSelectedChannel.push(e);
      }
    });
    /*    const elmTypesForSelectedChannel = elmTypes.filter(e =>
      TemplateDesignElementsRegistration.some(r => r.channelUId === channelUId && r.viewControlType == e.value)
    );*/

    // get the list of unique section numbers that are in use
    // so that we only show section headers that contain items
    const sections = elmTypesForSelectedChannel.map(t => t.section);
    this.elementSections = [...new Set(sections)];

    return elmTypesForSelectedChannel;
  }

  constructor(private translateService: TranslateService, private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngOnDestroy(): void { }





  dragItem(event, controlType: TemplateViewControlType): void {
    const properties: TemplateViewControlAction = {
      actionType: ControlActionType.Add,
      controlType
    };

    const propertyData = JSON.stringify(properties);

    event.dataTransfer.setData('text/plain', propertyData);
  }

  trackElements(element) {
    return element.value;
  }
}
